'use client';
import React, { memo } from 'react';
import Link from 'next/link';
import {
  ArrowDownCircleIcon,
  ArrowUpCircleIcon,
  ArrowTrendingUpIcon,
  LifebuoyIcon,
} from '@heroicons/react/24/solid';
import { useTranslation } from 'react-i18next';

const ACTION_DEFS = [
  { id: 'qa-deposit', labelKey: 'deposit', icon: ArrowDownCircleIcon, href: '/transactions?tab=deposit' },
  { id: 'qa-withdraw', labelKey: 'withdraw', icon: ArrowUpCircleIcon, href: '/transactions?tab=withdraw' },
  { id: 'qa-trade', labelKey: 'trade', icon: ArrowTrendingUpIcon, href: '/trade-platform' },
  { id: 'qa-support', labelKey: 'support', icon: LifebuoyIcon, href: '/support' },
];

export default memo(function QuickActions() {
  const { t } = useTranslation();

  return (
    <div className="px-4 mb-5">
      <div className="grid grid-cols-4 gap-2">
        {ACTION_DEFS.map((a) => (
          <Link
            key={a.id}
            href={a.href}
            className="flex flex-col items-center gap-1.5 py-2 transition-all active:scale-95"
          >
            <a.icon
              className="w-12 h-12"
              style={{ color: 'var(--foreground)' }}
            />
            <span className="text-[10px] font-bold" style={{ color: 'var(--foreground)' }}>
              {t(a.labelKey)}
            </span>
          </Link>
        ))}
      </div>
    </div>
  );
});